export enum FormQuestionType {
    Text = 1,
    Numeric = 2,
    SingleChoice = 3,
    MultipleChoice = 4,
    Heading = 5,
    TextMessage = 6,
    MediaBank = 7,
    Attachment = 8,
}

export enum FormConditionType {
    Answered = 1,
    NotAnswered = 2,
    EqualsToPresetOption = 3,
}
export enum FormQuestionAction {
    Show = 1,
    Hide = 2,
}
